// @flow
import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';

import TextInput from './../../Inputs/TextInput';
import { LOGIN_FORM } from './../../../../constants/forms';
import { required, email } from '../../../../utils/validators';
import Button from './../../Inputs/Button';
import i18n from '../../../../i18n/i18n.js';

const ForgotPasswordForm = props => {
    const lng = props.lng;

    return (
        <Fragment>
            {/* header part wasn't rendering from Auth component */}
            <section id="ipx-maincontent">
                <form onSubmit={props.handleSubmit} className="formelements">
                    <Field
                        component={TextInput}
                        type="email"
                        name="email"
                        label={i18n.t('placeholder_email_address', { lng })}
                        className="labelholder"
                        validate={[required, email]}
                        lng={lng}
                        handleFocus={props.handleFocus}
                        active={props.name === 'email' ? props.active : false}
                        primaryColor={props.branding.paywall_primary_color}
                    />
                    <div id="pswinfo">
                        <span>{i18n.t('forgot_pass_text', { lng })}</span>
                    </div>
                    <div
                        className="passwordreset"
                        onClick={() => {
                            props.changeForm(LOGIN_FORM);
                        }}
                    >
                        <label>{i18n.t('remember_pass', { lng })}</label>
                    </div>
                    <div className="inplayer-buttonholder">
                        <div className="buttonholder">
                            <Button
                                text={i18n.t('reset', { lng })}
                                backgroundColor={
                                    props.branding.paywall_buttons_bg_color
                                }
                                touched={
                                    props.params && props.params.anyTouched
                                }
                                errors={
                                    props.params && props.params.syncErrors
                                        ? true
                                        : false
                                }
                            />
                        </div>
                    </div>
                </form>
            </section>
        </Fragment>
    );
};

export default reduxForm({
    form: 'forgotPassForm',
})(ForgotPasswordForm);



// WEBPACK FOOTER //
// ./src/ui/components/Forms/ForgotPassword/index.js